import type {
  OrderDeliveryHistoryBuyerResponseType,
  OrderDeliveryHistorySupplierResponseType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

type HistoryResponse =
  | OrderDeliveryHistoryBuyerResponseType
  | OrderDeliveryHistorySupplierResponseType;

export function useOrderDeliveryHistory(orderId: number, enabled: boolean) {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const audience = business?.Supplier ? "supplier" : "buyer";
  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.OrderDeliveryHistory,
      orderId,
      audience,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `orders/${orderId}/delivery-history/${audience}`,
      }).then(
        (response) => apiV2AssertResponse<HistoryResponse>(response).data,
      ),
    ...getDefaultQueryOptionsV2<HistoryResponse>({
      context: { scope: "business", user, business },
      options: {
        enabled,
        staleTime: 0,
        refetchOnWindowFocus: true,
        refetchInterval: 60_000,
        retry: 2,
      },
    }),
  });
}
